import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { ProductsBarComponent } from './products-bar/products-bar.component';
import { ProductComponent } from './product/product.component';
import { StoreButtonsComponent } from './store-buttons/store-buttons.component';
import { ProductMobileComponent } from './product-mobile/product-mobile.component';
import { ImageLinkComponent } from './image-link/image-link.component';
import { ResponsiveDirective } from './responsive.directive';

@NgModule({
  declarations: [
    AppComponent,
    ProductsBarComponent,
    ProductComponent,
    StoreButtonsComponent,
    ProductMobileComponent,
    ImageLinkComponent,
    ResponsiveDirective,
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
